import { useToast } from 'vue-toastification'

export const toast = {
  success: (message: string) => {
    const toastInstance = useToast()
    return toastInstance.success(message)
  },
  error: (message: string) => {
    const toastInstance = useToast()
    return toastInstance.error(message)
  },
  warning: (message: string) => {
    const toastInstance = useToast()
    return toastInstance.warning(message)
  },
  info: (message: string) => {
    const toastInstance = useToast()
    return toastInstance.info(message)
  }
}
